<template>
  <div class="user-manage">
    <!-- 条件搜索部分 -->
    <el-form class="zwx-form" key="mainForm" ref="mainForm" :model="mainForm" label-position="right" @submit.native.prevent>
      <div style="max-width: 750px;">
        <el-form-item label-width="70px" label="地区：">
          <zwx-select-area ref="areaSelect" @loadOver="areaIdLoadOver()" :zoneCode12From="zoneCode12From"
                            zoneTypeMax="0" zoneTypeMin="4" :showFullName="false" :disabled="false" :clearable="false"/>
        </el-form-item>
        <el-form-item label-width="70px" label="机构名称：">
          <el-input class="zwx-input" v-model="mainForm.unitNameLike" placeholder="请输入" @keyup.enter.native="search(1)"
                    clearable/>
        </el-form-item>
        <el-form-item label-width="70px" label="用户姓名：">
          <el-input class="zwx-input" v-model="mainForm.userNameLike" placeholder="请输入" @keyup.enter.native="search(1)"
                    clearable/>
        </el-form-item>
        <el-form-item label-width="70px" label="用户账号：">
          <el-input class="zwx-input" v-model="mainForm.userNoLike" placeholder="请输入" @keyup.enter.native="search(1)"
                    clearable/>
        </el-form-item>
        <el-form-item label-width="70px" label="状态：">
          <el-checkbox-group class="zwx-checkbox-group" v-model="mainForm.ifEnables">
            <el-checkbox class="zwx-checkbox" :label="true">启用</el-checkbox>
            <el-checkbox class="zwx-checkbox" :label="false">停用</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </div>
    </el-form>
    <el-divider class="base-divider"/>
    <div style="padding: 12px 20px;">
      <el-button class="zwx-button zwx-button-icontext-28" type="primary" icon="el-icon-search" @click="search(1)">查询
      </el-button>
      <el-button class="zwx-button zwx-button-icontext-28" icon="el-icon-plus" @click="add()"
                 v-if="$validate.checkbtns(btns[0])">添加
      </el-button>
    </div>
    <!-- 列表展示部分 -->
    <el-table class="zwx-table" style="width: 100%;" row-key="rid" :data="dataList" border stripe>
      <el-table-column prop="fkByUnitId.fkByZoneId.fullName" label="地区"
                       :width="$system.calWidth(dataList, 'fkByUnitId.fkByZoneId.fullName', '地区')" header-align="left"
                       align="left"></el-table-column>
      <el-table-column prop="fkByUnitId.unitName" label="机构名称"
                       :width="$system.calWidth(dataList, 'fkByUnitId.unitName', '机构名称')" header-align="left"
                       align="left"></el-table-column>
      <el-table-column prop="userName" label="用户姓名" :width="$system.calWidth(dataList, 'userName', '用户姓名')"
                       header-align="left" align="left"></el-table-column>
      <el-table-column prop="userNo" label="用户账号" :width="$system.calWidth(dataList, 'userNo', '用户账号')"
                       header-align="left" align="left"></el-table-column>
      <el-table-column fixed="right" label="操作"
                       :min-width="$system.calMinWidth({ wordNum: 20, arrowNum: 3, btnNum: 8 })" header-align="left"
                       align="left">
        <template slot-scope="scope">
          <el-button class="zwx-button zwx-button-text-26" type="text" icon="el-icon-arrow-right"
                     @click="detail(scope.row)">查看
          </el-button>
          <el-button class="zwx-button zwx-button-text-26" type="text" icon="el-icon-arrow-right"
                     @click="role(scope.row)"
                     v-if="$validate.checkbtns(btns[0]) && (users.ifSuperAdmin || users.uid !== scope.row.uid)">角色分配
          </el-button>
          <el-button class="zwx-button zwx-button-text-26" type="text" icon="el-icon-arrow-right"
                     @click="edit(scope.row)"
                     v-if="$validate.checkbtns(btns[0]) && (users.ifSuperAdmin || users.uid !== scope.row.uid)">编辑
          </el-button>
          <el-button class="zwx-button zwx-button-text-26"
                     :style="scope.row.ifEnable ? 'color: #e72b00 !important;' : ''" type="text"
                     @click="$system.msgbox(scope.row, '提示', scope.row.ifEnable ? '确定要停用吗？' : '确定要启用吗？', '确定', '取消', enable)"
                     v-if="$validate.checkbtns(btns[0]) && (users.ifSuperAdmin || users.uid !== scope.row.uid)">
            {{ scope.row.ifEnable ? '停用' : '启用' }}
          </el-button>
          <el-button class="zwx-button zwx-button-text-26" style="color: rgb(228, 128, 29) !important;" type="text"
                     @click="$system.msgbox(scope.row, '提示', '确定要重置密码吗？', '确定', '取消', resetPassword)"
                     v-if="$validate.checkbtns(btns[0]) && (users.ifSuperAdmin || users.uid !== scope.row.uid)">重置密码
          </el-button>
          <el-button class="zwx-button zwx-button-text-26" style="color: #e72b00 !important;" type="text"
                     @click="$system.msgbox(scope.row, '提示', '确定要解封账号吗？', '确定', '取消', userUnbanned)"
                     v-if="scope.row.ifBanned && $validate.checkbtns(btns[0]) && (users.ifSuperAdmin || users.uid !== scope.row.uid)">
            解封账号
          </el-button>
          <el-button class="zwx-button zwx-button-text-26" type="danger"
                     @click="$system.msgbox(scope.row, '提示', '确定要删除吗？', '确定', '取消', deletion)"
                     v-if="!scope.row.ifEnable && $validate.checkbtns(btns[0]) && (users.ifSuperAdmin || users.uid !== scope.row.uid)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器部分 -->
    <base-pagination :parentPage="currentPage" :pageSize="pageSize" :total="total" @currentChange="currentChange"/>
  </div>
</template>

<script>
export default {
  name: 'UserManage',
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      userSexCodeTypeCode: this.$route.meta.userSexCodeTypeCode,
      userNationCodeTypeCode: this.$route.meta.userNationCodeTypeCode,
      educationCodeTypeCode: this.$route.meta.educationCodeTypeCode,
      degreeCodeTypeCode: this.$route.meta.degreeCodeTypeCode,
      maritalStatusCodeTypeCode: this.$route.meta.maritalStatusCodeTypeCode,
      politicalLandscapeCodeTypeCode: this.$route.meta.politicalLandscapeCodeTypeCode,
      religionCodeTypeCode: this.$route.meta.religionCodeTypeCode,
      btns: ['0d2b90e747adf966'],
      zoneCode12From: undefined,
      mainForm: {
        unitNameLike: '',
        userNameLike: '',
        userNoLike: '',
        ifEnables: [true],
      },
      dataList: [],
      currentPage: 1,
      pageSize: 18,
      total: 0,
    }
  },
  created() {
    this.zoneCode12From = this.users.ifSuperAdmin ? '000000000000' : this.users.fkByUnitId.fkByZoneId.zoneCode12
  },
  mounted() {
    this.$emit('loading', true)
    this.$refs.areaSelect.initSearch()
  },
  activated() {
    if (this.$route.params.fresh) this.search(this.currentPage)
  },
  computed: {},
  methods: {
    currentChange(currentPage) {
      this.search(currentPage)
    },
    areaIdLoadOver() {
      this.search(this.currentPage)
    },
    search(currentPage) {
      this.$emit('loading', true)
      this.currentPage = currentPage
      let data = {
        currentPage: this.currentPage,
        areaId: this.$refs.areaSelect.getChooseArea().rid,
        unitNameLike: this.mainForm.unitNameLike,
        userNameLike: this.mainForm.userNameLike,
        userNoLike: this.mainForm.userNoLike,
        ifEnable: this.mainForm.ifEnables.length === 1 ? this.mainForm.ifEnables[0] : null,
      }
      this.$system.get(this.api + '/systematic/getUserInfoList-1', data, true, true, this.searchSuccess, this.error)
    },
    searchSuccess(data) {
      if (data.type === '00') {
        this.dataList = data.userInfoList
        this.total = data.userInfoCount
        this.pageSize = data.pageSize
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
      }
      this.$emit('loading', false)
    },
    enable(row) {
      this.$emit('loading', true)
      let data = {rid: row.rid, ifEnable: !row.ifEnable}
      this.$system.post(this.api + '/systematic/modifyUserInfoState-1', data, true, true, this.enableSuccess, this.error)
    },
    enableSuccess(data) {
      if (data.type === '00') {
        this.search(this.currentPage)
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    resetPassword(row) {
      this.$emit('loading', true)
      let data = {uid: row.uid}
      this.$system.post(this.api + '/systematic/resetPassword-1', data, true, true, this.resetPasswordSuccess, this.error)
    },
    resetPasswordSuccess(data) {
      if (data.type === '00') {
        this.$system.notify('成功', data.mess, 'success')
        this.$emit('loading', false)
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    userUnbanned(row) {
      this.$emit('loading', true)
      let data = {uid: row.uid}
      this.$system.post(this.api + '/systematic/userUnbanned-1', data, true, true, this.userUnbannedSuccess, this.error)
    },
    userUnbannedSuccess(data) {
      if (data.type === '00') {
        this.search(this.currentPage)
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    deletion(row) {
      this.$emit('loading', true)
      let data = {rid: row.rid}
      this.$system.post(this.api + '/systematic/deleteUserInfo-1', data, true, true, this.deletionSuccess, this.error)
    },
    deletionSuccess(data) {
      if (data.type === '00') {
        this.$system.notify('成功', data.mess, 'success')
        this.search(this.currentPage)
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    add() {
      this.$router.push({
        name: 'MsUserEdit',
        params: {
          userSexCodeTypeCode: this.userSexCodeTypeCode,
          userNationCodeTypeCode: this.userNationCodeTypeCode,
          educationCodeTypeCode: this.educationCodeTypeCode,
          degreeCodeTypeCode: this.degreeCodeTypeCode,
          maritalStatusCodeTypeCode: this.maritalStatusCodeTypeCode,
          politicalLandscapeCodeTypeCode: this.politicalLandscapeCodeTypeCode,
          religionCodeTypeCode: this.religionCodeTypeCode
        }
      })
    },
    edit(row) {
      this.$router.push({
        name: 'MsUserEdit',
        params: {
          rid: row.rid,
          userSexCodeTypeCode: this.userSexCodeTypeCode,
          userNationCodeTypeCode: this.userNationCodeTypeCode,
          educationCodeTypeCode: this.educationCodeTypeCode,
          degreeCodeTypeCode: this.degreeCodeTypeCode,
          maritalStatusCodeTypeCode: this.maritalStatusCodeTypeCode,
          politicalLandscapeCodeTypeCode: this.politicalLandscapeCodeTypeCode,
          religionCodeTypeCode: this.religionCodeTypeCode
        }
      })
    },
    detail(row) {
      this.$router.push({name: 'UserDetail', params: {rid: row.rid}})
    },
    role(row) {
      this.$router.push({name: 'UserRole', params: {uid: row.uid, userName: row.userName}})
    },
    error() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
    },
  },
}
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
